(function () {
    'use strict';

    angular
        .module('app')
        .controller('TaskEditCtrl', TaskEditCtrl);

    TaskEditCtrl.$inject = [
        '$scope',
        '$q',
        '$location',
        '$routeParams',
        'TasksService',
        'NavigationAidService',
        'DialogService',
        'EntityTemplatesService',
        'UnsavedChangesService',
        'ObjectSaveErrorHandlerService',
        'WindowTitleService',
        'LastUpdatedService',
        'TagsService',
        'Task'];

    function TaskEditCtrl(
        $scope,
        $q,
        $location,
        $routeParams,
        TasksService,
        NavigationAidService,
        DialogService,
        EntityTemplatesService,
        UnsavedChangesService,
        ObjectSaveErrorHandlerService,
        WindowTitleService,
        LastUpdatedService,
        TagsService,
        Task) {

        /* jshint validthis:true */
        var vm = this;
        vm.task = {};
        vm.tags = null;
        vm.historyListApi = {};
        vm.deleteTask = deleteTask;
        vm.saveTask = saveTask;
        vm.completeTask = completeTask;
        vm.copyTask = copyTask;
        vm.close = close;
        vm.showTab = showTab;
        vm.loading = true;
        vm.notFound = false;
        vm.currentTabPage = 'details';
        Object.defineProperty(vm, 'lastUpdatedLabel', { get: function () { return LastUpdatedService.getTaskLabel(vm.task); } });
        vm.viewTitle = '';
        Object.defineProperty(vm, 'toggleCompleteLabel', {
            get: function () { return vm.task.data.Completed ? 'Mark Uncomplete' : 'Mark Complete'; }
        });
        Object.defineProperty(vm, 'dirty', {
            get: function () { return !_.isNil(UnsavedChangesService) && UnsavedChangesService.dirty; }
        });
        Object.defineProperty(vm, 'selectedDays', {
            get: getSelectedDays
        });
        Object.defineProperty(vm, 'endDateValid', {
            get: function () {
                return (_.isNil(vm.task.data.RepeatDetails.EndDate) || vm.task.data.RepeatDetails.EndDate === '' || vm.task.data.Completed) || moment(new Date(vm.task.data.RepeatDetails.EndDate)).isSameOrAfter(vm.task.data.Due, 'day');
            }
        });
        Object.defineProperty(vm, 'repeat', {
            get: function () { return !_.isNil(vm.task) && !_.isNil(vm.task.data) && !_.isNil(vm.task.data.Frequency) && vm.task.data.Frequency !== 'Once'; },
            set: function (value) {
                if (_.isNil(vm.task) || _.isNil(vm.task.data)) {
                } else if (value) {
                    vm.task.data.Frequency = 'Daily';
                } else {
                    vm.task.data.Frequency = 'Once';
                }
            }
        });

        Object.defineProperty(vm, 'occurrence', {
            get: function () {
                switch (vm.task.data.Frequency) {
                    case 'Daily':
                        return vm.task.data.RepeatDetails.Days;
                    case 'Weekly':
                        return vm.task.data.RepeatDetails.Weeks;
                    case 'Monthly':
                        return vm.task.data.RepeatDetails.Months;
                }
            },
            set: function (value) {
                switch (vm.task.data.Frequency) {
                    case 'Daily':
                        vm.task.data.RepeatDetails.Days = value;
                        break;
                    case 'Weekly':
                        vm.task.data.RepeatDetails.Weeks = value;
                        break;
                    case 'Monthly':
                        vm.task.data.RepeatDetails.Months = value;
                        break;
                }
            }
        });

        activate();
        
        function activate() {
            updateViewTitle();

            NavigationAidService.watchTabPage($scope, 'vm.currentTabPage');

            var loadPromises = [];
            loadPromises.push(loadTask());
            loadPromises.push(loadUserEntityTemplate());
            loadPromises.push(loadTags());

            $q.all(loadPromises).finally(function () {
                vm.loading = false;
                updateViewTitle();

                var currentTabFromHistory = NavigationAidService.getCurrentTabPage();
                if (!_.isNil(currentTabFromHistory)) {
                    // Load tab page from history
                    if (vm.showTab(currentTabFromHistory)) {
                        vm.currentTabPage = currentTabFromHistory;
                    }
                }

                registerWatches();
            });
        }


        /*
         * Loads existing task if an id was provided, otherwise if 'new' was supplied
         * a new task will be created. The UnsavedChanges service is then initialised.
         */
        function loadTask() {
            var getTaskPromise;

            if ($routeParams.id && $routeParams.id !== 'new') {
                getTaskPromise = Task.get($routeParams.id);
            } else if ($routeParams.copyTaskId) {
                getTaskPromise = Task.copyTask($routeParams.copyTaskId);
            } else {
                getTaskPromise = Task.getNew($routeParams.entityId);
            }

            return getTaskPromise
                .then(getTaskOk, getTaskError);

            function getTaskOk(data) {
                vm.task = data;

                UnsavedChangesService.register({
                    scope: $scope,
                    modelExpression: 'vm.task',
                    saveFunction: saveTask,
                    unsavedItemName: 'Task'
                });

                if ($routeParams.copyTaskId) {
                    UnsavedChangesService.dirty = true;
                }
            }

            function getTaskError(response) {
                if (response.status === 404) {
                    vm.notFound = true;
                } else {
                    DialogService.error('Error fetching Task', response);
                }
            }
        }

        /*
         * Loads the user entity template
         */
        function loadUserEntityTemplate() {
            return EntityTemplatesService.query({
                EntityType: 'User'
            })
                .then(getEntityTemplatesOk, getEntityTemplatesError);

            function getEntityTemplatesOk(data) {
                if (data.TemplateCount > 0) {
                    vm.userEntityTemplate = data.EntityTemplates[0];
                }
                else {
                    DialogService.error('User Entity Template was not found');
                }
            }

            function getEntityTemplatesError(response) {
                DialogService.error('Error fetching User Entity Template', response);
            }
        }

        /**
         * Load tags into the vm.tags variable.
         *
         * @returns {promise} A promise that resolves once the tags are loaded, or an error occurred.
         */
        function loadTags() {
            return TagsService.query({ tagUsage: 'Task' })
                .then(getTagsOk, getTagsError);

            function getTagsOk(data) {
                vm.tags = data.Tags;
            }

            function getTagsError(response) {
                DialogService.error('Error fetching Tags', response);
            }
        }

        /**
         * Delete the task.
         */
        function deleteTask() {
            if (!vm.task.taskIsNew) {
                DialogService.confirm('Delete the Task?', 'Task delete confirm')
                    .then(deleteOk);
            } else {
                promptUserToSaveForOperation('deleting');
            }

            function deleteOk() {
                TasksService.remove(vm.task.data.Id)
                    .then(deleteTaskOk, deleteTaskError);

                function deleteTaskOk(success) {
                    NavigationAidService.goBack();
                }

                function deleteTaskError(response) {
                    DialogService.error('Error deleting Task', response);
                }
            }
        }

        /**
         * Save the task
         *
         * @returns {Promise} A promise that resolves once saving is finished.
         */
        function saveTask() {
            var promise = null;

            if (!_.isNil(vm.addTaskForm) && vm.addTaskForm.$invalid) {
                promise = DialogService.messageList('Error saving Task', null, vm.addTaskForm.$error)
                    .then(function () {
                        return $q.reject();
                    });
            } else {

                promise = vm.task.save()
                    .then(saveTaskOk, saveTaskError);
            }

            return promise;

            /*
             * If task was new, the view will be redirected. Otherwise the current task details will be updated to match those that were persisted.
             */
            function saveTaskOk(task) {
                if (vm.task.taskIsNew) {
                    UnsavedChangesService.dirty = false;
                    NavigationAidService.replacePage('tasks/' + task);
                } else {
                    unregisterWatches();

                    vm.task.data = task;
                    vm.historyListApi.refresh();
                    vm.addTaskForm.$setPristine();

                    UnsavedChangesService.register({
                        scope: $scope,
                        modelExpression: 'vm.task',
                        saveFunction: saveTask,
                        unsavedItemName: 'Task'
                    });

                    updateViewTitle();

                    registerWatches();
                }
            }

            function saveTaskError(response) {
                return ObjectSaveErrorHandlerService.handleObjectSaveError(
                    response,
                    vm.task.data,
                    'Task',
                    vm.saveTask,
                    function () {
                        return TasksService.get($routeParams.id);
                    });
            }
        }

        /*
         * Complete/uncomplete the task, with the operation being opposite of the current data.Completed property.
         * E.g. A completed task would be uncomplete while an uncompleted task would be completed.
         */
        function completeTask() {
            if (_.isNil(vm.task.data.Id) || vm.task.data.Id === '') {
                promptUserToSaveForOperation('marking complete');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges('Task')
                        .then(function () {
                            saveTask().then(function () {
                                showCompleteTaskDialog();
                            });
                        });
                } else {
                    showCompleteTaskDialog();
                }
            }

            function showCompleteTaskDialog() {
                DialogService.show({
                    locals: {
                        complete: !vm.task.data.Completed,
                        prefilledNote: vm.task.data.Note
                    },
                    controller: 'CompleteTaskDialogCtrl',
                    controllerAs: 'vm',
                    templateUrl: 'app/task/complete-task-dialog.tmpl.html'
                })
                    .then(completeTaskDialogOk);

                function completeTaskDialogOk(completeTaskNote) {
                    TasksService.completeTasks(!vm.task.data.Completed, [vm.task.data.Id], completeTaskNote)
                        .then(completeTasksOk)
                        .catch(completeTasksError);

                    function completeTasksOk(response) {
                        NavigationAidService.goBack();
                    }

                    function completeTasksError(response) {
                        DialogService.error('Error ' + (vm.task.Completed ? 'uncompleting' : 'completing') + ' Task', response);
                    }
                }
            }
        }

        /**
         * Redirects the user to a view with a copy of the current task.
         */
        function copyTask() {
            if (_.isNil(vm.task.data.Id) || vm.task.data.Id === '') {
                promptUserToSaveForOperation('copying');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges('Task')
                        .then(function () {
                            saveTask().then(function () {
                                $location.url('tasks/new?copyTaskId=' + vm.task.data.Id);
                            });
                        });
                } else {
                    $location.url('tasks/new?copyTaskId=' + vm.task.data.Id);
                }
            }
        }

        /**
         * Determine if tab option should be shown.
         *
         * @param {string} tabName - Name of the tab e.g. 'details', 'items', 'history'.
         * @returns {bool} Should the tab be shown.
         */
        function showTab(tabName) {
            if (tabName === 'details') {
                // Always show details tab
                return true;
            }

            if (vm.loading || (!_.isNil(vm.task) && !vm.task.taskPersisted)) {
                // Only show other tabs if the task is found, and fully loaded
                return false;
            }

            // If none of the above criteria were met, show the tab
            return true;
        }

        /**
         * Update Title to be shown at the top of the view and browser window/tab title.
         */
        function updateViewTitle() {
            var title = '';

            if (!_.isNil($routeParams.id) && $routeParams.id !== '') {
                if ($routeParams.id === 'new') {
                    title = 'Add Task';
                } else {
                    title = 'Task';

                    if (!_.isNil(vm.task) && !_.isNil(vm.task.data) && !_.isNil(vm.task.data.Subject)) {
                        title += ' - ' + vm.task.data.Subject;
                    }
                }
            }

            vm.viewTitle = title;
            WindowTitleService.setTitle(title);
        }

        /*
         * When conducting an operation which requires a saved task and the task is new, a 'save task' prompt needs to be shown
         *
         * @param {string} operationName - Name of operation that was being conducted
         */
        function promptUserToSaveForOperation(operationName) {
            return DialogService.show({
                controller: 'SaveItemDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/controls/dialog/save-item-dialog.tmpl.html',
                locals: { name: 'task', operation: operationName }
            })
            .then(function () {
                return saveTask();
            });
        }

        /**
         * When the view is 'closed' navigation to a previous page should occur.
         */
        function close() {
            NavigationAidService.goBack();
        }

        /*
         * Function which checks to see if the supplied day reference matches a selected day.
         *
         * @param {int} day - Day reference which is to be checked against the selected days
         *
         * @returns {bool} - Returns true if the day is selected, otherwise false.
         */
        function isDaySelected(day) {
            return _.some(vm.selectedDays, function (dayReference) { return dayReference === day; });
        }

        /**
         * Set the due date using the start date as a starting point
         *
         * @param {string/date} startDateValue - The start date value which will be used to calculate the new due date
         */
        function setDueDateFromStartDate(startDateValue) {
            var startDate = moment(startDateValue);
            var dueDate = new Date(vm.task.data.Due);

            var year = startDate.year();
            var month = startDate.month();
            var day = startDate.date();
            var hour = dueDate.getHours();
            var minute = dueDate.getMinutes();

            // If it's a monthly task, the day of month needs to be set and the current monthy may be skipped
            if (!_.isNil(vm.task.data.RepeatDetails) &&
                !_.isNil(vm.task.data.RepeatDetails.Day)) {
                if (day > vm.task.data.RepeatDetails.Day) {
                    month++;
                }

                day = vm.task.data.RepeatDetails.Day;
            }

            var calculatedDate = moment(new Date(year, month, day, hour, minute));

            // If it's a weekly repeating task, the day of the week may have to be set
            if (!_.isNil(vm.task.data.RepeatDetails) && !_.isNil(vm.task.data.RepeatDetails.Weeks) && vm.selectedDays.length > 0) {
                for (var i = 0; i <= 6; i++) {
                    if (isDaySelected(calculatedDate.day())) {
                        break;
                    }

                    calculatedDate.date(calculatedDate.date() + 1);
                }

                vm.task.data.RepeatDetails.DaysUsedForCurrentWeek = [];
            }

            vm.task.data.Due = calculatedDate;
        }

        /**
         * Get the days which are currently selected for a 'Weekly' repeating task.
         * The day values are the reference integer used by moment.js. 'Sunday as 0 and Saturday as 6'
         *
         * @returns {array} - List of integers referencing what days are currently selected
         */
        function getSelectedDays() {
            var selectedDays = [];
            if (vm.task.data.RepeatDetails.Sunday) {
                selectedDays.push(0);
            }
            if (vm.task.data.RepeatDetails.Monday) {
                selectedDays.push(1);
            }
            if (vm.task.data.RepeatDetails.Tuesday) {
                selectedDays.push(2);
            }
            if (vm.task.data.RepeatDetails.Wednesday) {
                selectedDays.push(3);
            }
            if (vm.task.data.RepeatDetails.Thursday) {
                selectedDays.push(4);
            }
            if (vm.task.data.RepeatDetails.Friday) {
                selectedDays.push(5);
            }
            if (vm.task.data.RepeatDetails.Saturday) {
                selectedDays.push(6);
            }

            if (!_.isEqual(getSelectedDays.selectedDays, selectedDays)) {
                getSelectedDays.selectedDays = selectedDays;
            }

            return getSelectedDays.selectedDays;
        }

        /*
         * Register watches for Frequency and RepeatDetails. These are used to re-calculate the due date.
         */
        function registerWatches() {
            unregisterWatches();

            unregisterWatches.unbindFrequency = $scope.$watch('vm.task.data.Frequency', function (newVal, oldVal) {
                if (!_.isEqual(newVal, oldVal)) {
                    if (newVal !== 'Once') {
                        var repeatDetailsCopy = angular.copy(vm.task.data.RepeatDetails);
                        var frequencyNumber = 1;

                        if (!_.isNil(repeatDetailsCopy)) {
                            if (!_.isNil(repeatDetailsCopy.Days)) {
                            frequencyNumber = repeatDetailsCopy.Days;
                            } else if (!_.isNil(repeatDetailsCopy.Weeks)) {
                                frequencyNumber = repeatDetailsCopy.Weeks;
                            } else if (!_.isNil(repeatDetailsCopy.Months)) {
                                frequencyNumber = repeatDetailsCopy.Months;
                            }
                        }

                        switch (newVal) {
                            case 'Daily':
                                vm.task.data.RepeatDetails = { Days: frequencyNumber };
                                break;
                            case 'Weekly':
                                vm.task.data.RepeatDetails = { Weeks: frequencyNumber };
                                break;
                            case 'Monthly':
                                vm.task.data.RepeatDetails = { Months: frequencyNumber, Day: 1 };
                                break;
                        }

                        if (!_.isNil(repeatDetailsCopy)) {
                            vm.task.data.RepeatDetails.StartDate = repeatDetailsCopy.StartDate;
                            vm.task.data.RepeatDetails.EndDate = repeatDetailsCopy.EndDate;
                        } else {
                            vm.task.data.RepeatDetails.StartDate = moment(vm.task.data.Due).format('Y-MM-DD');
                        }

                        setDueDateFromStartDate(vm.task.data.RepeatDetails.StartDate);
                    } else {
                        vm.task.data.RepeatDetails = null;
                    }
                }
            });

            unregisterWatches.unbindRepeatDetails = $scope.$watch('vm.task.data.RepeatDetails', function (newVal, oldVal) {
                if (!_.isEqual(newVal, oldVal)) {
                    if (!_.isNil(newVal)) {
                        setDueDateFromStartDate(newVal.StartDate);
                    }
                }
            }, true);
        }

        /*
         * Unregister watches for Frequency and RepeatDetails.
         */
        function unregisterWatches() {
            if (!_.isNil(unregisterWatches.unbindFrequency)) {
                unregisterWatches.unbindFrequency();
            }
            if (!_.isNil(unregisterWatches.unbindRepeatDetails)) {
                unregisterWatches.unbindRepeatDetails();
            }
        }
    }
})();
